import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MultiFormSelectOptions } from '@stylehaven/components';
import { SavedQuerySearch } from '../../entities/saved-queries/saved-query-search.entity';
import { ISavedQuery, SavedQuery } from '../../entities/saved-queries/saved-query.entity';
import { PaginatedResults } from '../../record/entities/pagination/paginated-results.entity';
import { SavedQueriesService } from '../../services/saved-queries/saved-queries.service';
import { UserService } from '../../services/user/user.service';
import { ToastHelper } from '../../toast/service/toast.helper';

@Injectable({ providedIn: 'root' })
export class SavedQueriesSandboxService {
    constructor(
        private savedQueriesService: SavedQueriesService,
        private readonly userService: UserService,
        private toastHelper: ToastHelper
    ) {}

    addSavingToast() {
        return this.toastHelper.createStartToast('saved-queries.save');
    }

    updateSavingToastSuccess(toastId: number, link: string, linkText: string) {
        return this.toastHelper.updateToSuccess(toastId, 'saved-queries.save', 1, link, linkText);
    }

    updateSavingToastFailure(toastId: number) {
        return this.toastHelper.updateToFailure(toastId, 'saved-queries.save');
    }

    addUpdatingToast() {
        return this.toastHelper.createStartToast('saved-queries.update');
    }

    updateUpdatingToastSuccess(toastId: number) {
        return this.toastHelper.updateToSuccess(toastId, 'saved-queries.update');
    }

    updateUpdatingToastFailure(toastId: number) {
        return this.toastHelper.updateToFailure(toastId, 'saved-queries.update');
    }

    addDeletingToast() {
        return this.toastHelper.createStartToast('saved-queries.delete');
    }

    updateDeletingToastSuccess(toastId: number) {
        return this.toastHelper.updateToSuccess(toastId, 'saved-queries.delete');
    }

    updateDeletingToastFailure(toastId: number) {
        return this.toastHelper.updateToFailure(toastId, 'saved-queries.delete');
    }

    removeToast(toastId: number) {
        return this.toastHelper.remove(toastId);
    }

    public getGroupOptions(): Observable<MultiFormSelectOptions> {
        return this.userService.currentUser$.pipe(
            map(currentUser => currentUser.Groups),
            map(groups => groups.map(group => ({ label: group.Name, value: group.Id }))),
            map(formSelectOptions => ({ isLiveData: false, options: formSelectOptions }))
        );
    }

    public saveQuery(query: Partial<ISavedQuery>): Observable<SavedQuery> {
        return this.savedQueriesService.saveQuery(query);
    }

    public updateQuery(id: string, query: Partial<ISavedQuery>): Observable<void> {
        return this.savedQueriesService.updateQuery(id, query);
    }

    public getSavedQueries(search: SavedQuerySearch): Observable<PaginatedResults<SavedQuery>> {
        return this.savedQueriesService.getSavedQueries(search);
    }

    public getTotalSavedQueries(): Observable<number> {
        return this.savedQueriesService.getTotalSavedQueries();
    }

    public deleteQuery(id: string): Observable<void> {
        return this.savedQueriesService.delete(id);
    }
}
